/**
 * Contenido y reglas de validacion del formulario de registro.
 * Fuente unica de verdad para backoffice y app movil.
 */

const REGISTER_FORM = {
  title: "Crear Cuenta",
  subtitle: "Únete a CEAEmociones",
  labels: {
    name: "Nombre",
    surname: "Apellidos",
    email: "Correo electrónico",
    username: "Usuario",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
  },
  placeholders: {
    name: "Escribe tu nombre",
    surname: "Escribe tu apellido",
    email: "ejemplo@email.com",
    username: "Elige un nombre de usuario",
    password: "Mín. 8 caracteres, 1 letra, 1 número, 1 símbolo",
    confirmPassword: "Repite tu contraseña",
  },
  buttons: {
    submit: "Registrarse",
    login: "Iniciar sesión",
    loginLink: "¿Ya tienes cuenta? Inicia sesión",
  },
  messages: {
    success:
      "Registro realizado. Revisa tu correo y confirma tu cuenta.",
    errorRequired: "Por favor completa todos los campos",
    errorDuplicateUsername: "El nombre de usuario ya existe.",
    errorDuplicateEmail: "El email ya existe.",
    errorGeneric: "Error en el registro.",
  },
};

const PASSWORD_RULES = {
  minLength: 8,
  maxLength: 15,
  requireLetter: true,
  requireNumber: true,
  requireSymbol: true,
};

const USERNAME_RULES = {
  minLength: 3,
  maxLength: 20,
};

const VALIDATION_MESSAGES = {
  required: "Campo obligatorio",
  invalidEmail: "Email no válido",
  username: `El usuario debe tener entre ${USERNAME_RULES.minLength} y ${USERNAME_RULES.maxLength} caracteres`,
  password: `La contraseña debe tener mínimo ${PASSWORD_RULES.minLength} y máximo ${PASSWORD_RULES.maxLength} caracteres, e incluir al menos 1 letra, 1 número y 1 símbolo.`,
  passwordsNoMatch: "Las contraseñas no coinciden",
};

/**
 * Valida la fortaleza de una contraseña.
 * @param {string} password
 * @returns {string|null} Mensaje de error o null si es valida.
 */
function validatePassword(password) {
  if (
    password.length >= PASSWORD_RULES.minLength &&
    password.length <= PASSWORD_RULES.maxLength &&
    /[A-Za-z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  ) {
    return null;
  }
  return VALIDATION_MESSAGES.password;
}

/**
 * Valida un nombre de usuario.
 * @param {string} username
 * @returns {string|null} Mensaje de error o null si es valido.
 */
function validateUsername(username) {
  if (
    username.length >= USERNAME_RULES.minLength &&
    username.length <= USERNAME_RULES.maxLength
  ) {
    return null;
  }
  return VALIDATION_MESSAGES.username;
}

/**
 * Valida un email.
 * @param {string} email
 * @returns {boolean} true si el formato es valido.
 */
function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Devuelve el mensaje de error de la API de registro segun el codigo.
 * @param {string} errorCode
 * @returns {string}
 */
function getRegisterErrorMessage(errorCode) {
  if (errorCode === "DUPLICATE_USERNAME") return REGISTER_FORM.messages.errorDuplicateUsername;
  if (errorCode === "DUPLICATE_EMAIL") return REGISTER_FORM.messages.errorDuplicateEmail;
  return REGISTER_FORM.messages.errorGeneric;
}

module.exports = {
  REGISTER_FORM,
  PASSWORD_RULES,
  USERNAME_RULES,
  VALIDATION_MESSAGES,
  validatePassword,
  validateUsername,
  isValidEmail,
  getRegisterErrorMessage,
};
